module.exports = __webpack_public_path__ + "static/media/background.517667c6.svg";